// Promo Card Mutations

export const updatePromoCardList = (state, payload) => {
  state.promoCardList = payload
}

export const fetchPromoCardInfo = (state, payload) => {
  state.promoCardInfo = payload
}
